import { mtechnavi } from '~/shared/libs/clientsdk';
import {
  FullMethodName_ListBusinessUnitIntroductions,
  FullMethodName_ListGeneratedBusinessUnitIntroductionHistorys,
} from '~/worker';

// [データ取得] 自社企業（紹介情報）マスタ
export const listBusinessUnitIntroductions = async () => {
  return (await window.App.services.ui.worker.filter({
    action: 'reload',
    fullMethodName: FullMethodName_ListBusinessUnitIntroductions,
    filter: {},
    requestBody: {},
    sort: [], // ソートは画面項目セット時に行うため不要
  })) as mtechnavi.api.company.IListBusinessUnitIntroductionsResponse;
};

// [データ取得]自社企業（紹介情報）生成履歴マスタ
export const listGeneratedBusinessUnitIntroductionHistorys = async () => {
  return (await window.App.services.ui.worker.filter({
    action: 'reload',
    fullMethodName:
      FullMethodName_ListGeneratedBusinessUnitIntroductionHistorys,
    filter: {},
    requestBody: {},
    sort: [], // ソートは画面項目セット時に行うため不要
  })) as mtechnavi.api.company.IListGeneratedBusinessUnitIntroductionHistorysResponse;
};
